import { render } from "./ShareModal.vue?vue&type=template&id=64265766&scoped=true"
import script from "./ShareModal.vue?vue&type=script&lang=js"
export * from "./ShareModal.vue?vue&type=script&lang=js"

import "./ShareModal.vue?vue&type=style&index=0&id=64265766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64265766"]])

export default __exports__